import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useCredential } from 'components/hooks';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { CircularProgress, Backdrop } from '@mui/material';
import { CredentialFormDumb } from './CredentialFormDumb';

export const CredentialEditSmart = (props) => {
  const canEdit = props?.match?.path && props?.match?.path.indexOf('edit') !== -1 ?true:false;
  const { match: { params } } = props;
  const { credentialId } = params;
  const history = useHistory();
  const { cleanUpMessage, error, success, putCredential, getCredential, data, isLoaded } = useCredential();
  const [dataDefultLoaded, setDataDefaultLoaded] = useState(false);
  
  const [defaultValues, setDefaultValues] = useState({
    credentialId,
    companyId: '',
    name: '',
    description: '',
    company: '',
    type: 1,
    user: '',
    password: '',
    enabled: '',
    privateKey: '',
    token: '',
    sudo: '',
    tags: [],
    fromEdit: true
  });

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.CREDENTIAL_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put, success.get]);

  useLayoutEffect(() => {
    const query = { credential_id: credentialId }
    getCredential({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const body = {
      credential_id: data.credentialId,
      name: data.name,
      description: data.description,
      company: data.company,
      type: data.type,
      user: data.user,
      password: data.password,
      enabled: data.enabled,
      privateKey: data.privateKey,
      token: data.token,
      tags: data.tags,
      sudo: data.sudo
    };
    putCredential({ body });
  };

  function handleData() {
    const defaultdata = {
      credentialId: data.credential_id,
      companyId: data.company,
      name: data.name,
      description: data.description,
      company: data.company,
      type: data.type,
      user: data.user,
      password: data.password,
      enabled: data.enabled,
      privateKey: data.private_key,
      token: data.token,
      tags: data.tags,
      sudo: data.sudo,
      fromEdit: true
    }
    setDefaultValues({...defaultValues, ...defaultdata});
    setDataDefaultLoaded(true);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && dataDefultLoaded) ?
        (
          <CredentialFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
            canEdit={canEdit}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  )
}

export default withRequest(withRouter(CredentialEditSmart));
